// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"aa1b9b90","356":"d3b603c6","453":"bda8971a","694":"fed02794","788":"1e033d61","892":"de4e04a5"}[chunkId] + ".chunk.js";
};